

import React from "react";
import "./Header.css";
import image from "../../assets/Images/lehBikeExpedition.png";

const Header = () => {
  return (
    <div className="position-relative">
      {/* Video Background */}
      <div className="video-wrapper">
        <video
          autoPlay
          loop
          muted
          className="w-100 main-img"
        >
          <source
            src="https://viver-myexlusive-server.s3.ap-south-1.amazonaws.com/uploads/slider/thumb1920/Leh_Desktop.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </div>

      {/* Overlapping image below video */}
      {/* <div className="image-overlay-section" style={{ backgroundImage: `url(${image})` }}> */}
      <div className="image-overlay-section">
        <img src={image}  alt="Leh Bike Expedition" className="section-image" />
        <div className="image-overlay-text container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <hr style={{ width: "60px", border: "2px solid white" }} />
              <h1 className="overlay-heading">Chase Ladakh Summers</h1>
            </div>
            <div className="col-md-6">
              <p className="overlay-paragraph">
                When you visit Ladakh, you always have a unique experience to remember and share. Come along as we explore the beautiful and unique Himalayas together! We leave the main trails to explore the beautiful valleys and to see the ancient monasteries that define the local culture. You will experience something special in Leh Ladakh, along with the direction of our guides, amazing hospitality, and made-to-measure tours. The attraction of this place stays the same, no matter how many times you visit. Ladakh’s stunning views get you to visit, but what keeps you coming back are the people. So, let’s explore and make memories together! 
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
